import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import { useState, useEffect } from 'react';
import { createPopper } from '@popperjs/core';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var defaultPopperOptions = {};

function usePopper(parent, child, popperProps) {
  var _useState = useState(false),
      ready = _useState[0],
      setReady = _useState[1];

  useEffect(function () {
    var popperInstance;
    setReady(false);

    if (child && parent) {
      popperInstance = createPopper(parent, child, __spreadValues(__spreadValues({}, defaultPopperOptions), popperProps));
      setReady(true);
    }

    return function () {
      if (popperInstance) {
        popperInstance.destroy();
      }
    };
  }, [child, parent, popperProps]);
  return ready;
}

function usePopperWithRefs(triggerRef, contentRef, arrow, hasArrow, popperProps) {
  var _useState2 = useState(false),
      ready = _useState2[0],
      setReady = _useState2[1];

  useEffect(function () {
    var popperInstance;
    setReady(false);

    if (triggerRef.current && contentRef.current && (hasArrow && arrow || !hasArrow)) {
      popperInstance = createPopper(triggerRef.current, contentRef.current, __spreadValues(__spreadValues({}, defaultPopperOptions), popperProps));
      setReady(true);
    }

    return function () {
      if (popperInstance) {
        popperInstance.destroy();
        setReady(false);
      }
    };
  }, [triggerRef, contentRef, popperProps, arrow, hasArrow]);
  return ready;
}

export { usePopper, usePopperWithRefs };